// extracted by mini-css-extract-plugin
export default {"skeleton":"DXin2f0qllxQSLJUOzJ4","sscLoading":"qG3x7tFYiJ0DUNRHUOci"};